/* Buddy: add 'Les mer' accordion toggle to Shopify privacy banner body (mobile; hidden on desktop via CSS) */
(function(){
  function enhance(b){
    if(!b||b.classList.contains('buddy-pc-js'))return false;
    var p=b.querySelector('.shopify-pc__banner__body p');if(!p)return false;
    if(!p.id)p.id='buddy-pc-body-text';
    var t=document.createElement('button');t.type='button';t.className='buddy-pc-toggle';
    t.setAttribute('aria-expanded','false');t.setAttribute('aria-controls',p.id);t.textContent='Les mer';
    t.addEventListener('click',function(){var o=b.classList.toggle('buddy-pc-open');t.setAttribute('aria-expanded',o?'true':'false');t.textContent=o?'Vis mindre':'Les mer';});
    p.insertAdjacentElement('afterend',t);b.classList.add('buddy-pc-js');return true;
  }
  if(enhance(document.getElementById('shopify-pc__banner')))return;
  var mo=new MutationObserver(function(){if(enhance(document.getElementById('shopify-pc__banner')))mo.disconnect();});
  mo.observe(document.documentElement,{childList:true,subtree:true});
  setTimeout(function(){mo.disconnect();},30000);
})();
